import type { PlannedSpendingItems } from 'app-components/flux/free-to-spend/freeToSpendTypes';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'ADD_PLANNED_SPENDING_DIALOG';

export const addPlannedSpendingDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({
    freeToSpendId,
    plannedItems,
    startDate,
    initialId,
    callback,
  }: {
    freeToSpendId: string;
    plannedItems: PlannedSpendingItems;
    startDate: string;
    initialId?: string;
    callback?: (catName: string) => void;
  }) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({
        freeToSpendId,
        plannedItems,
        startDate,
        initialId,
        callback,
      }),
    }),
);
